// extracted by mini-css-extract-plugin
export default {"row":"info-row_row__87hJC","column":"info-row_column__Z+bWX","label":"info-row_label__8GrW2","value":"info-row_value__uL-DV"};